import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { FindManyResult } from "@/core/common/resource-base/find-many-result.dto";
import { IRequest } from "@/interfaces/IRequest";
import { cloneDeep } from "lodash";
import { ProjectHasCurrencyDto } from "./project-has-currency.dto";
import { CreateProjectHasCurrencyDto } from "./create-project-has-currency.dto";
import { UpdateProjectHasCurrencyDto } from "./update-project-has-currency.dto";

export class ProjectsHaveCurrenciesResource extends ResourceBaseService<
  ProjectHasCurrencyDto,
  CreateProjectHasCurrencyDto,
  UpdateProjectHasCurrencyDto
> {
  protected EntityDto = ProjectHasCurrencyDto;
  protected CreateEntityDto = CreateProjectHasCurrencyDto;
  protected UpdateEntityDto = UpdateProjectHasCurrencyDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/projects-have-currencies");
  }

  async getCurrencies(
    projectId: string,
    request: IRequest = {},
    includeArchived?: boolean
  ): Promise<FindManyResult<ProjectHasCurrencyDto>> {
    const req = cloneDeep(request);
    if (!req.join) req.join = [];
    if (!req.join.includes("currency")) {
      req.join.push("currency");
    }

    if (!req.filters) req.filters = {};
    Object.assign(req.filters, { projectId: projectId });

    if (req.search) {
      req.searchBy = ["currencyId", "currency.code", "currency.label"];
    }

    if (!req.sortBy) {
      req.sortBy = "currency.code";
    }

    return this.findAll(req, includeArchived);
  }
}
